import { ISubscription } from 'models/subscriptions.model'

import { googleAnalyticsLogger } from 'services/googleAnalytics.service'

import { TimeInterval } from 'root-constants'

import { createProductId } from './createProductId'
import { getSha256Hash } from './getSha256Hash'

export const logAddToCartPixelEvents = ({
  currency,
  email,
  fullPrice,
  trialPrice,
  periodQuantity,
  periodName,
  selectedSubscription,
  uuid,
  productName,
  isUpsell = false,
  isOneTimeUpsell = false,
}: {
  currency: string
  email: string
  fullPrice: number
  trialPrice?: number
  periodQuantity: number
  periodName: TimeInterval | null
  selectedSubscription: ISubscription
  uuid: string
  productName?: string
  isUpsell?: boolean
  isOneTimeUpsell?: boolean
}) => {
  const checkoutPrice = trialPrice || fullPrice
  const productId = isOneTimeUpsell
    ? productName
    : createProductId({
        periodName,
        periodQuantity,
        price: checkoutPrice,
      })

  if (!isUpsell) {
    window.ttq.identify({ email })
    window.ttq.track('AddToCart', { event_id: uuid })
  }

  window.fbq('track', 'AddToCart', {}, { eventID: uuid })

  if (!isUpsell) {
    window.snaptr &&
      window.snaptr('track', 'ADD_CART', {
        user_email: email,
      })
  }

  if (!isUpsell) {
    window.pintrk &&
      window.pintrk('track', 'addtocart', {
        value: checkoutPrice,
        currency: currency.toUpperCase(),
        event_id: uuid,
        order_quantity: 1,
        external_id: getSha256Hash(uuid),
        ...(email && { em: getSha256Hash(email) }),
        line_items: [
          {
            product_category: 'wellness',
            product_name: productId,
            product_id: productId,
            product_price: checkoutPrice,
            product_quantity: 1,
          },
        ],
      })
  }

  googleAnalyticsLogger.logAddingToCart(selectedSubscription as ISubscription)
}
